import FormInput from "@/components/forms/inputs/FormInput";

export default {
    components: { FormInput },
    props: {
        context: {
            type: Object,
            required: true,
        },
        meta: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            value: null,
            isLoading: false,
            emptyValue: null, // added by Mark - different field types will need different empty values -- ie: null, "", [], etc...
            // Django/DRF is very picky about this, null and "" are not the same
            // may also need array of all values to consier 'empty' -- if value is any of those, set value to 'emptyValue'
        };
    },
    watch: {
        value(value) {
            this.onValueChanged(value)
        },
        "context.model": {
            immediate: true,
            handler() {
                console.log(
                    "hello from context.model watch handler - this.context.model is",
                    this.context.model
                );
                this.value = this.parseValue(this.context.model);
            },
        },
    },
    computed: {
        defaults() {
            return {};
        },
        attributes() {
            return Object.assign({}, this.defaults, this.context.attributes);
        },
    },
    methods: {
        onValueChanged(value) {
            console.log(
                "hello from value watcher in MIXIN for label:",
                this.context.label,
                value
            );
            this.context.model = value;
        },
        parseValue(value) {
            console.log(
                "from parseValue in FormInputMixin - value=",
                value,
                "type=",
                typeof value
            );
            if (value && value !== "") {
                return value;
            }

            //return null;
            // changed by Mark - don't always return null if we have an 'empty' value
            // instead, return whatever we have set for 'emptyValue' - can override the default in each component where mixin is used
            return this.emptyValue;
        },
    },
};
